/* eslint-disable */
import { Mesh } from 'three';

import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils';

import IndustrialDoor from './Base';

import { metalMat, pinewoodBodyMat } from '../Materials';

const mediaBucketUrl = process.env.NEXT_PUBLIC_MEDIA_BUCKET_URL;

export default class LoftDoor extends IndustrialDoor {
  constructor(...args) {
    super(...args);

    const attributes = args[0];

    // load the key resources
    this.resourceManager.loadResources(['wheelSystem'], () => {
      this.update(attributes);
      this.renderFunc();
    });

    // Define the materials
    this.materialDefinitions = {
      metal: { ...metalMat },
      wood: {
        ...pinewoodBodyMat,
        aoMapIntensity: 2.5,
        uvScale: {
          u: 3,
          v: 3,
        },
      },
    };

    this.parameters.parcloseDepth = 10;

    this.initMaterials();
    this.update(attributes);
  }

  updateModelParameters(attributes) {
    const doorStyle = attributes['door-style']
      ? attributes['door-style']
      : 'vertical-0';
    const styleParams = doorStyle.split('-');
    this.parameters.style = styleParams[0];
    this.parameters.density = 0;

    // Set the new texture
    const doorColor = attributes['door-color']
      ? attributes['door-color']
      : attributes['door-color-oil']
      ? attributes['door-color-oil']
      : 'pinewood_oak';
    this.parameters.color = doorColor;
    this.materialDefinitions.wood.map = `${mediaBucketUrl}textures/1K/${doorColor}.jpg`;
    this.updateMaterial(this.materials.wood, this.materialDefinitions.wood);
  }

  buildModel() {
    const Frame = this.buildFrameGeometry();
    const Body = this.buildBodyGeometry();
    const Parclose = this.buildParcloseGeometry();
    const Hanger = this.buildHangerGeometry();

    Frame.forEach((geometry) => {
      this.group.add(new Mesh(geometry, this.materials.metal));
    });
    Body.forEach((geometry) => {
      this.group.add(new Mesh(geometry, this.materials.wood));
    });
    // if (Body) {
    //   this.group.add(
    //     new Mesh(
    //      BufferGeometryUtils.mergeGeometries(Body),
    //      this.materials.wood
    //    )
    //  );
    // }
    if (Parclose) {
      this.group.add(
        new Mesh(
          BufferGeometryUtils.mergeGeometries(Parclose),
          this.materials.metal
        )
      );
    }
    // Decoration.forEach((geometry) => {
    //   this.group.add(
    //     new Mesh(
    //       geometry,
    //       this.materials.mirror
    //     )
    //   );
    // });
    Hanger.forEach((geometry) => {
      this.group.add(new Mesh(geometry, this.materials.metal));
    });

    this.group.children.forEach((z) => {
      z.castShadow = true;
      z.receiveShadow = true;
    });

    this.group.position.y = -38;
  }
}
